module.exports = __webpack_public_path__ + "img/membranfonok.9f47c8ae.png";